"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _recompose = require("recompose");

var _Experiment = require("../experiments/Experiment/Experiment");

/**
 * Prevents the need to deeply nest <Experiment> components when running multiple
 * test. Fires an impression and returns "control" or "variation" in experiment prop.
 *
 *      Input: experimentName=sf_9564_ssdc_test_name
 *      Output: sf9564Variation=control/variation
 */
var withExperiment = function withExperiment(experimentName, logImpression) {
  if (logImpression === void 0) {
    logImpression = true;
  }

  return (0, _recompose.compose)((0, _recompose.withProps)(function (props) {
    return {
      name: experimentName,
      logImpression: (0, _isFunction2["default"])(logImpression) ? logImpression(props) : logImpression
    };
  }), _Experiment.enhance, (0, _recompose.withProps)(function (_ref) {
    var _ref2;

    var bucketedVariation = _ref.bucketedVariation;
    var pieces = experimentName.split('_');
    return _ref2 = {}, _ref2["" + pieces[0] + pieces[1] + "Variation"] = bucketedVariation, _ref2;
  }));
};

var _default = withExperiment;
exports["default"] = _default;